import Vue from "vue";
import { AbacoWebModule, ApplicationReadyEvent } from "@abaco/web-common/src/app";
import SatellitesWidgetApi from './api/SatellitesWidgetApi';
import globals from "./globals";
import { HTTPClient } from "@abaco/web-common/src/HTTP";
import DashboardChartsModule from "@abaco/dashboard-module/src/modules/charts/index";
import SSOModule from '@abaco/sso-web-module/src/abaco-module';
import FarmerRegistryModule from "@abaco/farm-registry/src/modules/farm-registry";
import GlobalStateModule from "@abaco/portal-global-state/src/modules/global-state";
import SatellitesWidgetVuexModule from "./state";

export const MODULE_ID = "satellites_widgets_module";
const state = new SatellitesWidgetVuexModule();
export default class SatellitesWidgetModule implements AbacoWebModule {
    public static MODULE_ID = MODULE_ID;

    readonly id = MODULE_ID;
    readonly globalComponents = globals;
    readonly vuexModule = state;

    private sateliteApi!: SatellitesWidgetApi;
    private apiCreated!: boolean;
    private ssoModule!: SSOModule;
    private siticatastoApi = "/siticatasto/dbgis-servlet";
    private indexesPath = "/indexes/api"

    dependsOn = {
        [FarmerRegistryModule.MODULE_ID]: () => new FarmerRegistryModule(),
        [GlobalStateModule.MODULE_ID]: () => new GlobalStateModule(),
        [DashboardChartsModule.MODULE_ID]: () => new DashboardChartsModule(),
    }

    async onApplicationReady(evt: ApplicationReadyEvent) {
        this.ssoModule = evt.modules.find((m) => m.id === SSOModule.MODULE_ID) as SSOModule;
    }

    async beforeEnterAnyRoutes(http: HTTPClient) {
        if (this.apiCreated) {
            return;
        }
        this.apiCreated = true;

        const SatellitesWidget = (await import("./api/SatellitesWidgetApi")).default;
        this.sateliteApi = new SatellitesWidget(http, this.siticatastoApi, this.indexesPath);
    }

    onRouterReady() {
        Vue.filter("onlyNDigits", (val: number, n: number) => { return `${Number(val).toLocaleString(undefined, {minimumFractionDigits: n, maximumFractionDigits: n})}`});
    }

    public get sateliteWidgetApi() {
        return this.sateliteApi;
    }
}
